import { Checkbox } from "../Checkbox";
import { BaseFilterConfig } from "./shared";

export interface CheckboxFilterConfig extends BaseFilterConfig {
  filterType: "Checkbox";
  initialFilterValue?: boolean;
}

export interface CheckboxFilterProps {
  filterConfig: CheckboxFilterConfig;
  value?: boolean;
  onChange?: (key: string, newValue: boolean) => void;
}

export function CheckboxFilter({ filterConfig, value = false, onChange }: CheckboxFilterProps) {
  const { key, label } = filterConfig;
  const handleChange = (checked: boolean) => {
    if (onChange) {
      onChange(key, checked);
    }
  };
  return <Checkbox label={label} checked={!!value} onChange={handleChange} />;
}
